import mixpanel from 'mixpanel-browser';
import { isProduction } from '../is-production';

export function initializeMixpanel(): void {
  try {
    mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN || '', { debug: !isProduction() });
    mixpanel.track('Session Start', { $direct: document.referrer || undefined });
  } catch {}
}
